export default __webpack_public_path__ + "static/media/cup.2657008f.svg";